(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-strip"] && !Shopify.designMode) return;
  try {
    
  function initialiseCategoryStrips(root) {
    const strips = root.matches?.('.category-strip__shell') ? [root] : [...root.querySelectorAll('.category-strip__shell')];
    strips.forEach((strip) => {
      if (strip.dataset.ready === 'true') return;
      const track = strip.querySelector('[data-category-track]');
      if (!track) return;
      strip.dataset.ready = 'true';
      const controller = new AbortController();
      const mobile = window.matchMedia('(max-width: 768px)');
      let resetFrame;
      const resetToStart = () => {
        if (!mobile.matches || track.scrollWidth <= track.clientWidth + 1) return;
        cancelAnimationFrame(resetFrame);
        track.classList.add('is-initialising');
        track.scrollTo({ left: 0, behavior: 'auto' });
        resetFrame = requestAnimationFrame(() => {
          track.scrollTo({ left: 0, behavior: 'auto' });
          track.classList.remove('is-initialising');
        });
      };
      strip.querySelector('[data-category-previous]')?.addEventListener('click', () => track.scrollBy({ left: -Math.max(track.clientWidth * 0.65, 240), behavior: 'smooth' }), { signal: controller.signal });
      strip.querySelector('[data-category-next]')?.addEventListener('click', () => track.scrollBy({ left: Math.max(track.clientWidth * 0.65, 240), behavior: 'smooth' }), { signal: controller.signal });
      mobile.addEventListener('change', (event) => {
        if (event.matches) resetToStart();
      }, { signal: controller.signal });
      strip.categoryCleanup = () => {
        controller.abort();
        cancelAnimationFrame(resetFrame);
        track.classList.remove('is-initialising');
        delete strip.dataset.ready;
        delete strip.categoryCleanup;
      };
      resetToStart();
    });
  }
  initialiseCategoryStrips(document);
  document.addEventListener('shopify:section:load', (event) => initialiseCategoryStrips(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const strips = event.target.matches?.('.category-strip__shell') ? [event.target] : [...event.target.querySelectorAll('.category-strip__shell')];
    strips.forEach((strip) => strip.categoryCleanup?.());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eo-valeria-editorial"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('[data-eo-image]');if(!button)return;const gallery=button.closest('.gallery');const image=gallery.querySelector('.eo-main-image');image.removeAttribute('srcset');image.src=button.dataset.eoImage;image.alt=button.dataset.eoAlt;gallery.querySelectorAll('[data-eo-image]').forEach(function(item){const active=item===button;item.classList.toggle('selected',active);item.setAttribute('aria-pressed',String(active));});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  const initialiseFooterAccordions=scope=>{const roots=scope.matches?.('[data-footer-accordions]')?[scope]:[...scope.querySelectorAll('[data-footer-accordions]')];roots.forEach(root=>{if(root.dataset.footerReady==='true')return;root.dataset.footerReady='true';const controller=new AbortController();const buttons=[...root.querySelectorAll('[data-footer-toggle]')];const media=window.matchMedia('(max-width: 768px)');const setState=(button,expanded)=>{const block=button.closest('.site-footer__block');button.setAttribute('aria-expanded',String(expanded));block.classList.toggle('is-collapsed',!expanded);button.dataset.mobileExpanded=String(expanded)};const sync=()=>{buttons.forEach((button,index)=>{if(media.matches){button.disabled=false;const stored=button.dataset.mobileExpanded;const expanded=stored===undefined?root.dataset.mobileFirstOpen==='true'&&index===0:stored==='true';setState(button,expanded)}else{button.disabled=true;button.setAttribute('aria-expanded','true');button.closest('.site-footer__block').classList.remove('is-collapsed')}})};buttons.forEach(button=>button.addEventListener('click',()=>{if(!media.matches)return;setState(button,button.getAttribute('aria-expanded')!=='true')},{signal:controller.signal}));media.addEventListener('change',sync,{signal:controller.signal});root.footerCleanup=()=>{controller.abort();delete root.dataset.footerReady};sync()})};initialiseFooterAccordions(document);document.addEventListener('shopify:section:load',event=>initialiseFooterAccordions(event.target));document.addEventListener('shopify:section:unload',event=>{const roots=event.target.matches?.('[data-footer-accordions]')?[event.target]:[...event.target.querySelectorAll('[data-footer-accordions]')];roots.forEach(root=>root.footerCleanup?.())});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  function initialisePredictiveSearch(scope) {
    const roots = scope.matches?.('[data-predictive-search-root]') ? [scope] : [...scope.querySelectorAll('[data-predictive-search-root]')];
    roots.forEach((root) => {
      if (root.dataset.predictiveReady === 'true' || root.dataset.enabled !== 'true') return;
      const input = root.querySelector('[data-predictive-search-input]');
      const results = root.querySelector('[data-predictive-search-results]');
      if (!input || !results || !root.dataset.endpoint) return;
      root.dataset.predictiveReady = 'true';
      let timer;
      let request;
      const clear = () => {
        request?.abort();
        results.replaceChildren();
        input.setAttribute('aria-expanded', 'false');
      };
      const search = async () => {
        const query = input.value.trim();
        if (query.length < 2) return clear();
        request?.abort();
        request = new AbortController();
        results.innerHTML = '<p class="predictive-search__status">Searching…</p>';
        const url = new URL(root.dataset.endpoint, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('section_id', 'predictive-search');
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', root.dataset.limit || '4');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        try {
          const response = await fetch(url, { signal: request.signal });
          if (!response.ok) throw new Error('Predictive search failed');
          const markup = await response.text();
          const documentResult = new DOMParser().parseFromString(markup, 'text/html');
          const sectionResult = documentResult.querySelector('#shopify-section-predictive-search');
          results.innerHTML = sectionResult ? sectionResult.innerHTML : markup;
          input.setAttribute('aria-expanded', 'true');
        } catch (error) {
          if (error.name !== 'AbortError') clear();
        }
      };
      input.addEventListener('input', () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(search, 220);
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') clear();
        if (event.key === 'ArrowDown') {
          const first = results.querySelector('[role="option"] a');
          if (first) {
            event.preventDefault();
            first.focus();
          }
        }
      });
      results.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'ArrowUp', 'Escape'].includes(event.key)) return;
        const links = [...results.querySelectorAll('[role="option"] a')];
        const current = links.indexOf(document.activeElement);
        if (event.key === 'Escape') {
          event.preventDefault();
          input.focus();
          return clear();
        }
        if (current < 0) return;
        event.preventDefault();
        const next = event.key === 'ArrowDown' ? links[current + 1] : links[current - 1];
        if (next) next.focus();
        else input.focus();
      });
    });
  }
  initialisePredictiveSearch(document);
  document.addEventListener('shopify:section:load', (event) => initialisePredictiveSearch(event.target));
  // Accordion behaviour is scoped to siblings: opening Boots closes Sandals,
  // but keeps their parent Shoes open. Collection names remain normal links.
  function closeMobileSubmenu(toggle) {
    const panelId = toggle.getAttribute('aria-controls');
    const panel = panelId && document.getElementById(panelId);
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', `Expand ${toggle.dataset.submenuTitle} submenu`);
    if (!panel) return;
    panel.hidden = true;
    // Reset descendants so they start closed if this branch is reopened.
    panel.querySelectorAll('[data-mobile-submenu-toggle]').forEach((nestedToggle) => {
      nestedToggle.setAttribute('aria-expanded', 'false');
      nestedToggle.setAttribute('aria-label', `Expand ${nestedToggle.dataset.submenuTitle} submenu`);
      const nestedId = nestedToggle.getAttribute('aria-controls');
      const nestedPanel = nestedId && document.getElementById(nestedId);
      if (nestedPanel) nestedPanel.hidden = true;
    });
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-mobile-submenu-toggle]');
    if (!toggle || !toggle.closest('#MobileMenu')) return;
    const panelId = toggle.getAttribute('aria-controls');
    const panel = panelId && document.getElementById(panelId);
    if (!panel) return;

    if (toggle.getAttribute('aria-expanded') === 'true') {
      closeMobileSubmenu(toggle);
      return;
    }

    // Only close items at the SAME depth in the SAME parent list.
    // This keeps ancestors (e.g. Shoes) open when toggling a child (e.g. Boots).
    const currentItem = toggle.closest('li.drawer__item');
    if (currentItem) {
      const siblings = currentItem.parentElement?.children || [];
      Array.from(siblings).forEach((sibling) => {
        if (sibling === currentItem) return;
        const siblingToggle = sibling.querySelector(':scope > .drawer__menu-row > [data-mobile-submenu-toggle]');
        if (siblingToggle && siblingToggle.getAttribute('aria-expanded') === 'true') {
          closeMobileSubmenu(siblingToggle);
        }
      });
    }

    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', `Collapse ${toggle.dataset.submenuTitle} submenu`);
    panel.hidden = false;
  });

  // DESKTOP ONLY. Hover opens menus; clicking a category name follows its link.
  // Arrow buttons remain accessible for keyboard and non-hover input devices.
  // Mobile accordion logic above is deliberately untouched.
  function closeDesktopBranch(toggle) {
    const panelId = toggle.getAttribute('aria-controls');
    const panel = panelId && document.getElementById(panelId);
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', `Expand ${toggle.dataset.desktopTitle} submenu`);
    if (!panel) return;
    panel.hidden = true;
    panel.querySelectorAll('[data-desktop-toggle]').forEach((nestedToggle) => {
      nestedToggle.setAttribute('aria-expanded', 'false');
      nestedToggle.setAttribute('aria-label', `Expand ${nestedToggle.dataset.desktopTitle} submenu`);
      const nestedPanelId = nestedToggle.getAttribute('aria-controls');
      const nestedPanel = nestedPanelId && document.getElementById(nestedPanelId);
      if (nestedPanel) nestedPanel.hidden = true;
    });
  }
  function positionDesktopSimpleDropdown(toggle, panel) {
    if (!panel?.classList.contains('desktop-nav__dropdown--simple')) return;
    const header = panel.closest('.site-header-wrap');
    const item = toggle.closest('.desktop-nav__item--simple');
    if (!header || !item) return;
    const headerRect = header.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();
    const panelWidth = panel.getBoundingClientRect().width;
    const desiredCenter = itemRect.left + itemRect.width / 2 - headerRect.left;
    const safeCenter = Math.max(panelWidth / 2 + 12,
      Math.min(headerRect.width - panelWidth / 2 - 12, desiredCenter));
    panel.style.setProperty('--desktop-dropdown-center', `${safeCenter}px`);
  }
  function openDesktopBranch(toggle) {
    const panelId = toggle.getAttribute('aria-controls');
    const panel = panelId && document.getElementById(panelId);
    if (!panel) return;
    const currentItem = toggle.closest('[data-desktop-item]');
    if (currentItem) {
      Array.from(currentItem.parentElement?.children || []).forEach((sibling) => {
        if (sibling === currentItem) return;
        const siblingToggle = sibling.querySelector(':scope > .desktop-nav__row > [data-desktop-toggle]');
        if (siblingToggle?.getAttribute('aria-expanded') === 'true') closeDesktopBranch(siblingToggle);
      });
    }
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', `Collapse ${toggle.dataset.desktopTitle} submenu`);
    panel.hidden = false;
    positionDesktopSimpleDropdown(toggle, panel);
  }
  function closeAllDesktopBranches(nav) {
    nav.querySelectorAll(':scope > ul > [data-desktop-item] > .desktop-nav__row > [data-desktop-toggle]').forEach((toggle) => {
      if (toggle.getAttribute('aria-expanded') === 'true') closeDesktopBranch(toggle);
    });
  }
  function initialiseDesktopHover(scope) {
    const navs = scope.matches?.('[data-desktop-nav]')
      ? [scope]
      : [...scope.querySelectorAll('[data-desktop-nav]')];
    navs.forEach((nav) => {
      if (nav.dataset.desktopHoverReady === 'true') return;
      nav.dataset.desktopHoverReady = 'true';
      let closeTimer;
      const clearCloseTimer = () => window.clearTimeout(closeTimer);
      const mouseCanHover = (event) =>
        window.matchMedia('(min-width: 769px) and (hover: hover) and (pointer: fine)').matches &&
        (event.pointerType === 'mouse' || event.pointerType === 'pen');

      nav.addEventListener('pointerover', (event) => {
        if (!mouseCanHover(event)) return;
        clearCloseTimer();
        const item = event.target.closest('.desktop-nav__item');
        if (!item || !nav.contains(item)) return;
        const toggle = item.querySelector(':scope > .desktop-nav__row > [data-desktop-toggle]');
        if (!toggle) closeAllDesktopBranches(nav);
        else if (toggle.getAttribute('aria-expanded') !== 'true') openDesktopBranch(toggle);
      });
      // A small delay avoids flicker when the pointer crosses the header edge.
      nav.addEventListener('pointerleave', (event) => {
        if (!mouseCanHover(event)) return;
        clearCloseTimer();
        closeTimer = window.setTimeout(() => {
          if (!nav.matches(':hover')) closeAllDesktopBranches(nav);
        }, 190);
      });
      nav.addEventListener('pointerenter', clearCloseTimer);
      // Focus navigation gives keyboard users the same discoverable submenus.
      nav.addEventListener('focusin', (event) => {
        const item = event.target.closest('.desktop-nav__item');
        if (!item) return;
        const toggle = item.querySelector(':scope > .desktop-nav__row > [data-desktop-toggle]');
        if (!toggle) closeAllDesktopBranches(nav);
        else if (toggle.getAttribute('aria-expanded') !== 'true') openDesktopBranch(toggle);
      });
      nav.addEventListener('focusout', (event) => {
        if (!nav.contains(event.relatedTarget)) closeAllDesktopBranches(nav);
      });
    });
  }
  initialiseDesktopHover(document);
  document.addEventListener('shopify:section:load', (event) => initialiseDesktopHover(event.target));
  window.addEventListener('resize', () => {
    document.querySelectorAll('.desktop-nav__item--simple > .desktop-nav__row > [data-desktop-toggle][aria-expanded="true"]').forEach((toggle) => {
      positionDesktopSimpleDropdown(toggle, document.getElementById(toggle.getAttribute('aria-controls')));
    });
  });

  document.addEventListener('click', (event) => {
    const nav = event.target.closest('[data-desktop-nav]');
    if (!nav) {
      document.querySelectorAll('[data-desktop-nav]').forEach(closeAllDesktopBranches);
      return;
    }
    const toggle = event.target.closest('[data-desktop-toggle]');
    if (!toggle) return; // Name links ALWAYS navigate on the first click.
    event.preventDefault();
    if (toggle.getAttribute('aria-expanded') === 'true') closeDesktopBranch(toggle);
    else openDesktopBranch(toggle);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-desktop-nav]').forEach((nav) => {
      const openTop = nav.querySelector(':scope > ul > [data-desktop-item] > .desktop-nav__row > [data-desktop-toggle][aria-expanded="true"]');
      if (!openTop) return;
      if (nav.contains(document.activeElement)) {
        event.preventDefault();
        const visibleTarget = getComputedStyle(openTop).display === 'none'
          ? openTop.parentElement.querySelector('[data-desktop-name]')
          : openTop;
        visibleTarget?.focus();
      }
      closeAllDesktopBranches(nav);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manual-reviews"] && !Shopify.designMode) return;
  try {
    
  const initialiseReviewCarousels = (scope) => {
    const roots = scope.matches?.('[data-review-carousel]') ? [scope] : [...scope.querySelectorAll('[data-review-carousel]')];
    roots.forEach((root) => {
      if (root.dataset.reviewReady === 'true') return;
      const viewport = root.querySelector('[data-review-track]');
      const track = viewport?.querySelector('.manual-reviews__track');
      const originals = [...root.querySelectorAll('[data-review-card]')];
      if (!viewport || !track || originals.length === 0) return;

      root.dataset.reviewReady = 'true';
      const controller = new AbortController();
      const signal = controller.signal;
      const dots = [...root.querySelectorAll('[data-review-dot]')];
      const previous = root.querySelector('[data-review-prev]');
      const next = root.querySelector('[data-review-next]');
      const total = originals.length;
      const configuredColumns = Number(getComputedStyle(root).getPropertyValue('--reviews-columns')) || 3;
      root.style.setProperty('--reviews-effective-columns', String(Math.min(total, configuredColumns)));
      let slides = [];
      let physical = total;
      let scrollTimer;
      let autoplayTimer;
      let resetting = false;

      const realIndex = (index) => ((index - total) % total + total) % total;
      const makeClone = (card, index) => {
        const clone = card.cloneNode(true);
        clone.removeAttribute('data-review-card');
        clone.removeAttribute('data-shopify-editor-block');
        clone.dataset.reviewClone = 'true';
        clone.dataset.reviewSlide = 'true';
        clone.dataset.reviewIndex = String(index);
        clone.setAttribute('aria-hidden', 'true');
        clone.inert = true;
        return clone;
      };
      originals.forEach((card, index) => {
        card.dataset.reviewIndex = String(index);
        card.dataset.reviewSlide = 'true';
      });
      if (total > 1) {
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();
        originals.forEach((card, index) => {
          before.append(makeClone(card, index));
          after.append(makeClone(card, index));
        });
        track.prepend(before);
        track.append(after);
      }
      slides = [...track.querySelectorAll('[data-review-slide]')];

      const destination = (index) => slides[index].offsetLeft + slides[index].clientWidth / 2 - viewport.clientWidth / 2;
      const nearest = () => {
        const centre = viewport.scrollLeft + viewport.clientWidth / 2;
        let match = 0;
        let distance = Infinity;
        slides.forEach((slide, index) => {
          const nextDistance = Math.abs(slide.offsetLeft + slide.clientWidth / 2 - centre);
          if (nextDistance < distance) {
            distance = nextDistance;
            match = index;
          }
        });
        return match;
      };
      const update = (index) => {
        physical = index;
        const current = realIndex(physical);
        slides.forEach((slide, slideIndex) => slide.classList.toggle('is-selected', slideIndex === physical));
        dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === current)));
      };
      const jump = (index) => {
        resetting = true;
        window.clearTimeout(scrollTimer);
        viewport.classList.add('is-loop-resetting');
        physical = index;
        viewport.scrollTo({ left: destination(physical), behavior: 'auto' });
        update(physical);
        void viewport.offsetWidth;
        viewport.classList.remove('is-loop-resetting');
        resetting = false;
      };
      const normalise = () => {
        if (resetting) return;
        physical = nearest();
        if (total > 1 && physical < total) return jump(physical + total);
        if (total > 1 && physical >= total * 2) return jump(physical - total);
        update(physical);
      };
      const settle = () => {
        window.clearTimeout(scrollTimer);
        normalise();
      };
      const move = (index) => {
        physical = index;
        viewport.scrollTo({ left: destination(physical), behavior: 'smooth' });
        update(physical);
      };
      const step = (direction) => {
        normalise();
        move(physical + direction);
      };
      const stopAutoplay = () => {
        if (!autoplayTimer) return;
        window.clearInterval(autoplayTimer);
        autoplayTimer = undefined;
      };

      previous?.addEventListener('click', () => {
        stopAutoplay();
        step(-1);
      }, { signal });
      next?.addEventListener('click', () => {
        stopAutoplay();
        step(1);
      }, { signal });
      dots.forEach((dot, index) => dot.addEventListener('click', () => {
        stopAutoplay();
        const options = total > 1 ? [index, index + total, index + total * 2] : [index];
        const target = options.reduce((best, value) => Math.abs(value - physical) < Math.abs(best - physical) ? value : best, options[0]);
        move(target);
      }, { signal }));
      viewport.addEventListener('scroll', () => {
        if (resetting) return;
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(settle, 140);
      }, { passive: true, signal });
      viewport.addEventListener('scrollend', settle, { signal });
      viewport.addEventListener('dragscroll:end', (event) => {
        stopAutoplay();
        const near = nearest();
        const threshold = slides[near].clientWidth * .12;
        if (Math.abs(event.detail.distance) > threshold && realIndex(near) === realIndex(physical)) move(physical + (event.detail.distance > 0 ? 1 : -1));
        else move(near);
      }, { signal });
      viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          stopAutoplay();
          step(-1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          stopAutoplay();
          step(1);
        }
      }, { signal });

      const observer = new ResizeObserver(() => jump(total > 1 ? total + realIndex(physical) : 0));
      observer.observe(viewport);
      const speed = Number(root.dataset.autoplay || 0);
      if (speed > 0 && total > 1) autoplayTimer = window.setInterval(() => step(1), speed * 1000);
      root.reviewCleanup = () => {
        controller.abort();
        observer.disconnect();
        window.clearTimeout(scrollTimer);
        stopAutoplay();
        root.querySelectorAll('[data-review-clone]').forEach((clone) => clone.remove());
        delete root.dataset.reviewReady;
        delete root.reviewCleanup;
      };
      jump(total > 1 ? total : 0);
    });
  };
  initialiseReviewCarousels(document);
  document.addEventListener('shopify:section:load', (event) => initialiseReviewCarousels(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const roots = event.target.matches?.('[data-review-carousel]') ? [event.target] : [...event.target.querySelectorAll('[data-review-carousel]')];
    roots.forEach((root) => root.reviewCleanup?.());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const initialiseRecommendationCarousels = (scope) => {
    const grids = scope.matches?.('.product-recommendations .product-grid')
      ? [scope]
      : [...scope.querySelectorAll('.product-recommendations .product-grid')];

    grids.forEach((grid) => {
      if (grid.dataset.dragScrollReady === 'true') return;
      grid.dataset.dragScrollReady = 'true';

      let mouseDown = false;
      let startX = 0;
      let startScrollLeft = 0;
      let didDrag = false;
      let suppressNextClick = false;

      /* Prevent the browser's native image drag without interfering with links. */
      grid.addEventListener('dragstart', (event) => {
        if (event.target.closest('img')) event.preventDefault();
      });

      grid.addEventListener('mousedown', (event) => {
        if (event.button !== 0) return;
        mouseDown = true;
        didDrag = false;
        suppressNextClick = false;
        startX = event.clientX;
        startScrollLeft = grid.scrollLeft;
      });

      window.addEventListener('mousemove', (event) => {
        if (!mouseDown) return;
        const distance = event.clientX - startX;

        if (!didDrag && Math.abs(distance) > 6) {
          didDrag = true;
          grid.classList.add('is-dragging');
        }

        if (!didDrag) return;
        event.preventDefault();
        grid.scrollLeft = startScrollLeft - distance;
      }, { passive: false });

      window.addEventListener('mouseup', () => {
        if (!mouseDown) return;
        mouseDown = false;

        if (didDrag) {
          suppressNextClick = true;
          setTimeout(() => { suppressNextClick = false; }, 180);
        }

        grid.classList.remove('is-dragging');
        didDrag = false;
      });

      /* Only cancel the click that immediately follows an actual drag.
         Normal clicks on product image/title links remain untouched. */
      grid.addEventListener('click', (event) => {
        if (!suppressNextClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressNextClick = false;
      }, true);
    });
  };

  const initialiseProductRecommendations = (scope) => {
    const roots = scope.matches?.('[data-product-recommendations]') ? [scope] : [...scope.querySelectorAll('[data-product-recommendations]')];
    roots.forEach((root) => {
      if (root.dataset.recommendationsReady === 'true') return;
      root.dataset.recommendationsReady = 'true';
      const currentProductId = root.dataset.currentProductId;
      const prepareContent = (content) => {
        const seen = new Set(currentProductId ? [currentProductId] : []);
        [...content.querySelectorAll('[data-product-id]')].forEach((card) => {
          const id = card.dataset.productId;
          if (!id || seen.has(id)) card.remove();
          else seen.add(id);
        });
        return content.querySelector('[data-product-id]') ? content : null;
      };
      const showContent = (content) => {
        const prepared = prepareContent(content);
        if (!prepared) return false;
        root.replaceChildren(prepared);
        root.hidden = false;
        root.setAttribute('aria-busy', 'false');
        initialiseRecommendationCarousels(root);
        return true;
      };
      const showFallback = (source) => {
        const fallback = source.querySelector('[data-recommendations-fallback]') || root.querySelector('[data-recommendations-fallback]');
        if (!fallback) return false;
        return showContent(fallback.content.cloneNode(true));
      };
      fetch(root.dataset.url)
        .then((response) => {
          if (!response.ok) throw new Error(`Product recommendations request failed: ${response.status}`);
          return response.text();
        })
        .then((text) => {
          const page = document.createElement('div');
          page.innerHTML = text;
          const replacement = page.querySelector('[data-product-recommendations]');
          const content = replacement?.querySelector('.product-recommendations__content');
          if (content && showContent(content.cloneNode(true))) return;
          if (replacement && showFallback(replacement)) return;
          root.remove();
        })
        .catch(() => {
          if (!showFallback(root)) root.remove();
        });
    });
  };
  initialiseProductRecommendations(document);
  initialiseRecommendationCarousels(document);
  document.addEventListener('shopify:section:load', (event) => {
    initialiseProductRecommendations(event.target);
    initialiseRecommendationCarousels(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-bar"] && !Shopify.designMode) return;
  try {
    
  const initialiseTrustCarousels = (scope) => {
    const roots = scope.matches?.('[data-trust-carousel]') ? [scope] : [...scope.querySelectorAll('[data-trust-carousel]')];
    roots.forEach((root) => {
      if (root.dataset.trustReady === 'true') return;
      const viewport = root.querySelector('[data-trust-viewport]');
      const track = root.querySelector('[data-trust-track]');
      const originals = [...root.querySelectorAll('[data-trust-item]')];
      if (!viewport || !track || originals.length === 0) return;

      root.dataset.trustReady = 'true';
      const controller = new AbortController();
      const signal = controller.signal;
      const dots = [...root.querySelectorAll('[data-trust-dot]')];
      const media = window.matchMedia('(max-width: 768px)');
      const enabled = root.dataset.mobileCarousel === 'true' && originals.length > 1;
      const total = originals.length;
      let slides = originals;
      let physical = 0;
      let active = false;
      let scrollTimer;
      let resetting = false;

      const realIndex = (index) => ((index - total) % total + total) % total;
      const makeClone = (item, index) => {
        const clone = item.cloneNode(true);
        clone.removeAttribute('data-trust-item');
        clone.removeAttribute('data-shopify-editor-block');
        clone.dataset.trustClone = 'true';
        clone.dataset.trustSlide = 'true';
        clone.dataset.trustIndex = String(index);
        clone.setAttribute('aria-hidden', 'true');
        clone.inert = true;
        return clone;
      };
      originals.forEach((item, index) => {
        item.dataset.trustSlide = 'true';
        item.dataset.trustIndex = String(index);
      });

      const destination = (index) => slides[index].offsetLeft + slides[index].clientWidth / 2 - viewport.clientWidth / 2;
      const nearest = () => {
        const centre = viewport.scrollLeft + viewport.clientWidth / 2;
        let match = 0;
        let distance = Infinity;
        slides.forEach((slide, index) => {
          const nextDistance = Math.abs(slide.offsetLeft + slide.clientWidth / 2 - centre);
          if (nextDistance < distance) {
            distance = nextDistance;
            match = index;
          }
        });
        return match;
      };
      const update = (index) => {
        physical = index;
        const current = active ? realIndex(physical) : Math.max(0, index);
        slides.forEach((slide, slideIndex) => slide.classList.toggle('is-selected', slideIndex === physical));
        dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === current)));
      };
      const jump = (index) => {
        resetting = true;
        window.clearTimeout(scrollTimer);
        viewport.classList.add('is-loop-resetting');
        physical = index;
        viewport.scrollTo({ left: active ? destination(physical) : 0, behavior: 'auto' });
        update(physical);
        void viewport.offsetWidth;
        viewport.classList.remove('is-loop-resetting');
        resetting = false;
      };
      const normalise = () => {
        if (!active || resetting) return;
        physical = nearest();
        if (physical < total) return jump(physical + total);
        if (physical >= total * 2) return jump(physical - total);
        update(physical);
      };
      const settle = () => {
        window.clearTimeout(scrollTimer);
        normalise();
      };
      const move = (index) => {
        if (!active) return;
        physical = index;
        viewport.scrollTo({ left: destination(physical), behavior: 'smooth' });
        update(physical);
      };
      const rebuild = () => {
        window.clearTimeout(scrollTimer);
        root.querySelectorAll('[data-trust-clone]').forEach((clone) => clone.remove());
        active = enabled && media.matches;
        if (active) {
          const before = document.createDocumentFragment();
          const after = document.createDocumentFragment();
          originals.forEach((item, index) => {
            before.append(makeClone(item, index));
            after.append(makeClone(item, index));
          });
          track.prepend(before);
          track.append(after);
          slides = [...track.querySelectorAll('[data-trust-slide]')];
          jump(total);
        } else {
          slides = originals;
          jump(0);
        }
      };

      dots.forEach((dot, index) => dot.addEventListener('click', () => {
        if (!active) return;
        const options = [index, index + total, index + total * 2];
        const target = options.reduce((best, value) => Math.abs(value - physical) < Math.abs(best - physical) ? value : best, options[0]);
        move(target);
      }, { signal }));
      viewport.addEventListener('scroll', () => {
        if (!active || resetting) return;
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(settle, 140);
      }, { passive: true, signal });
      viewport.addEventListener('scrollend', settle, { signal });
      viewport.addEventListener('dragscroll:end', (event) => {
        if (!active) return;
        const near = nearest();
        const threshold = slides[near].clientWidth * .12;
        if (Math.abs(event.detail.distance) > threshold && realIndex(near) === realIndex(physical)) move(physical + (event.detail.distance > 0 ? 1 : -1));
        else move(near);
      }, { signal });
      viewport.addEventListener('keydown', (event) => {
        if (!active) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          normalise();
          move(physical - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          normalise();
          move(physical + 1);
        }
      }, { signal });

      const resizeObserver = new ResizeObserver(() => {
        if (active) jump(total + realIndex(physical));
      });
      resizeObserver.observe(viewport);
      media.addEventListener('change', rebuild, { signal });
      root.trustCleanup = () => {
        controller.abort();
        resizeObserver.disconnect();
        window.clearTimeout(scrollTimer);
        root.querySelectorAll('[data-trust-clone]').forEach((clone) => clone.remove());
        delete root.dataset.trustReady;
        delete root.trustCleanup;
      };
      rebuild();
    });
  };
  initialiseTrustCarousels(document);
  document.addEventListener('shopify:section:load', (event) => initialiseTrustCarousels(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const roots = event.target.matches?.('[data-trust-carousel]') ? [event.target] : [...event.target.querySelectorAll('[data-trust-carousel]')];
    roots.forEach((root) => root.trustCleanup?.());
  });

  } catch(e) { console.error(e); }
})();
})();
